import React from 'react'
import PropTypes from 'prop-types'
import {
  COLORS,
  TEXT_SIZES,
} from '@helpers/constants'
import Text from '@components/Text'
import Icon from '@components/Icon'
import classNames from 'classnames'

const BookOption = (props) => {
  const {
    innerRef,
    innerProps,
    data: { book, hasSection },
    isSelected,
  } = props
  const {
    id,
    level,
    schoolYear,
  } = book

  return (
    <div
      key={id}
      className={classNames(
        `w-full border-mediumGrey px-4 py-2 border-mediumGrey border-b`,
        `first:hover:rounded-t last:hover:rounded-b last:border-none`,
        `${hasSection ? '' : 'cursor-pointer hover:bg-secondaryGreen'}`
      )}
      ref={innerRef}
      {...innerProps}
    >
      <div className={'relative flex items-center justify-between'}>
        <div className='flex items-center flex-grow'>
          {isSelected &&
            <div className={'pr-2'}>
              <Icon icon={'CheckMark'}/>
            </div>
          }
          <Text
            color={hasSection ? COLORS.MEDIUM_GREY.TEXT : null}
            bold
          >
            {book.name}
          </Text>
        </div>
        <div className={`flex justify-center w-[15%] ${hasSection ? 'border-mediumGrey' : null} border-l`}>
          <Text
            color={hasSection ? COLORS.MEDIUM_GREY.TEXT : null}
            size={TEXT_SIZES.XXSMALL}
          >
            {schoolYear.name}
          </Text>
        </div>
        <div className={`flex w-[18%] pl-8 ${hasSection ? 'border-mediumGrey' : null} border-l`}>
          <Text
            color={hasSection ? COLORS.MEDIUM_GREY.TEXT : null}
            size={TEXT_SIZES.XXSMALL}
          >
            {level.name}
          </Text>
        </div>
      </div>
    </div>
  )
}

BookOption.propTypes = {
  book: PropTypes.object,
  selectedSectionId: PropTypes.string,
  hasSection: PropTypes.bool,
}

export default BookOption
